'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useButton } from '@react-aria/button';
import { Fragment } from 'react';
import { setToString } from '../../../core/utilities/set.utils.js';
import { useFloatingLabelFormElement } from '../../contexts/internal/floating-label/index.js';
import { useSwanListboxButtonContext } from './listbox-button.context.js';
import { useSelectedItems } from './use-selected-items.hook.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { useFormFieldProps } from '../form/form.context.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(e);
        for(o = 0; o < l.length; o++)r = l[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, l = Object.keys(e);
    for(o = 0; o < l.length; o++)r = l[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
let SelectedOptions = ({ className: t, placeholder: r })=>{
    let { selectedItems: n, selectedItemsOrFirst: i } = useSelectedItems(), s = new Set(t), p = '';
    if (0 === n.length && null != r) p = r;
    else if (1 === i.length) {
        var c, a, u, b, f;
        let e = i[0];
        p = null !== (f = null !== (b = null !== (u = null == e ? void 0 : null === (c = e.props) || void 0 === c ? void 0 : c.label) && void 0 !== u ? u : null == e ? void 0 : e.rendered) && void 0 !== b ? b : null == e ? void 0 : e.textValue) && void 0 !== f ? f : '', (null == e ? void 0 : null === (a = e.props) || void 0 === a ? void 0 : a.disabled) && s.add('swan-listbox-button-disabled-option');
    } else p = i.reduce((t, r, n)=>{
        var l, s, p, c;
        let a = null == r ? void 0 : r.props, u = null !== (s = null == r ? void 0 : null === (l = r.value) || void 0 === l ? void 0 : l.toString()) && void 0 !== s ? s : n, d = [
            ...t,
            jsx(Fragment, {
                children: null !== (c = null !== (p = a.label) && void 0 !== p ? p : null == r ? void 0 : r.rendered) && void 0 !== c ? c : null == r ? void 0 : r.textValue
            }, u)
        ];
        return n < i.length - 1 && d.push(jsx(Fragment, {
            children: ', '
        }, `${u},`)), d;
    }, []);
    return jsx("span", {
        className: setToString(s),
        children: p
    });
};
const ListboxButton = renderWithRef('ListboxButton', {}, (o, l)=>{
    var { className: s, labelPrefix: d, placeholder: b } = o, f = _object_without_properties(o, [
        "className",
        "labelPrefix",
        "placeholder"
    ]);
    let { triggerRef: m } = useSwanPopover(), { triggerProps: v, triggerDisabled: O, skin: _ } = useSwanListboxButtonContext(), j = assignRefs(l, m), { buttonProps: y } = useButton(v, m), w = useFloatingLabelFormElement(_object_spread_props(_object_spread({}, f), {
        placeholder: void 0,
        id: y.id
    })), h = useFormFieldProps(w.id), g = new Set([
        'swan-listbox-button'
    ]);
    return d && g.add('swan-listbox-button-with-label'), ('error' === _ || h['aria-invalid']) && g.add('swan-listbox-skin-error'), s && g.add(s), jsxs(RenderComp, {
        root: "button",
        forwardedRef: j,
        classNames: g,
        props: _object_spread_props(_object_spread({}, y, w, h), {
            disabled: O
        }),
        children: [
            d ? jsx("span", {
                className: "swan-listbox-button-label",
                children: d
            }) : null,
            jsx(SelectedOptions, {
                placeholder: b
            })
        ]
    });
});

export { ListboxButton };
